import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isProfileComplete } from '../utils/profileCompletion';

function ProtectedRoute({ children, user, requiredRole = null, authChecking = false, requireProfileComplete = true }) {
  const location = useLocation();
  const isProfilePage = location.pathname === '/profile';
  
  // Show loading state while checking authentication from localStorage
  if (authChecking) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Check if user is authenticated
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Check role if required
  if (requiredRole) {
    const userRole = user?.role?.name;
    const isAdmin = userRole === 'super_admin' || userRole === 'administrator' || userRole === 'manager';
    const isCourier = userRole === 'courier';
    
    if (requiredRole === 'admin' && !isAdmin && !isCourier) {
      return <Navigate to="/" replace />;
    }
    
    if (requiredRole === 'super_admin' && userRole !== 'super_admin') {
      return <Navigate to="/" replace />;
    }
  }

  // Check if profile is complete (skip check on profile page itself and if explicitly disabled)
  // Also skip for admin/courier roles as they may not need to complete customer profile
  if (requireProfileComplete && !isProfilePage) {
    const userRole = user?.role?.name;
    const isAdmin = userRole === 'super_admin' || userRole === 'administrator' || userRole === 'manager';
    const isCourier = userRole === 'courier';
    
    // Only require profile completion for regular customers
    if (!isAdmin && !isCourier && !isProfileComplete(user)) {
      return <Navigate to="/profile" replace />;
    }
  }

  return children;
}

export default ProtectedRoute;
